import React from "react";
import { CheckIcon } from "lucide-react";
import { volumes } from "../data/content";
export function Volumes() {
  return <section className="px-5 py-16 md:py-24" data-id="element-301" data-mp="1lw1xm0mc0mpq">
      <div className="mx-auto max-w-4xl" data-id="element-302" data-mp="183vjsl6nirtg">
        <h2 className="text-center font-display text-[30px] font-extrabold leading-tight text-ink md:text-5xl" data-id="element-303" data-mp="184wx6wb53qec">
          What's inside <em className="text-plum-600" data-id="element-304" data-mp="1c5qh7elgol1y">Implant Decision System™?</em>
        </h2>
        <p className="mt-3 text-center text-[17px] text-ink/70" data-id="element-305" data-mp="1zwcmwz7ztt8s">6 premium volumes, one decision at a time.</p>

        <ol className="mt-10 space-y-5" data-id="element-306" data-mp="24tcx9mbvli5p">
          {volumes.map(v => <li key={v.number} className="overflow-hidden rounded-3xl bg-white shadow-[0_2px_24px_-8px_rgba(42,16,69,0.18)]" data-id="element-307" data-mp="1qtbn1g9q0ydk">
              <div className="flex items-center gap-4 px-6 py-4 text-white" style={{
            backgroundColor: v.color
          }} data-id="element-308" data-mp="1vrmw3os6z4uq">
                <span className="font-display text-4xl font-black leading-none" data-id="element-309" data-mp="fhkjzcqvcuxp">{v.number}</span>
                <div data-id="element-310" data-mp="kby6epnjzrq8">
                  <p className="text-xs font-bold uppercase tracking-widest opacity-80" data-id="element-311" data-mp="3o7wu2hvwr8zq">Volume {v.number}</p>
                  <p className="text-[15px] font-semibold leading-tight" data-id="element-312" data-mp="3j9lk875m4yhi">{v.subtitle}</p>
                </div>
              </div>
              <div className="p-6 md:p-8" data-id="element-313" data-mp="21q5m0ooqitc">
                <h3 className="font-display text-2xl font-extrabold leading-tight text-ink md:text-3xl" data-id="element-314" data-mp="1ylyovju58yz">{v.title}</h3>
                <p className="mt-3 text-[16px] leading-relaxed text-ink/75" data-id="element-315" data-mp="b1d70mhezome">{v.description}</p>
                <p className="mt-5 text-sm font-bold uppercase tracking-wide text-ink/50" data-id="element-316" data-mp="62tl2m2tmcu1">Inside:</p>
                <ul className="mt-3 grid gap-2.5 sm:grid-cols-2" data-id="element-317" data-mp="kr6kjt14adta">
                  {v.inside.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] leading-snug text-ink/85" data-id="element-318" data-mp="fs3eq6dbc3k9">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0" style={{
                  color: v.color
                }} strokeWidth={3} aria-hidden data-id="element-319" data-mp="tt64at3invzx" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}